module.exports = __webpack_public_path__ + "static/img/name5.7e33aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/th/name5.png
// module id = pkPz
// module chunks = 1